// CompletedContests.js
import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import useSortedContests from '../contests/hooks/useSortedContests';
import { useAuth } from '../../context/AuthContext';

const CompletedContests = () => {
  const { contests } = useOutletContext();
  const { userId } = useAuth();
  const { sortedContests, requestSort, sortConfig } = useSortedContests(
    contests || [],
    'deadline',
    'descending'
  );
  const navigate = useNavigate();

  const handleContestClick = (contestId) => {
    navigate(`/contests/completed/${contestId}`);
  };

  const getWinnerName = (contest) => {
    return contest.placementResults?.[0]?.entrants?.[0]?.entryName || 'N/A';
  };

  const getEntrantsCount = (contest) => {
    return contest.entrantsCount || 0;
  };

  const getSortIndicator = (key) => {
    if (!sortConfig || sortConfig.key !== key) return '';
    return sortConfig.direction === 'ascending' ? '▲' : '▼';
  };

  if (!contests || contests.length === 0) {
    return <div className="contests-table-container"><p>No completed contests found.</p></div>;
  }

  return (
    <div className="completed-contests-container">
      <div>
        <div className="contests-table-container">
          <table className="contests-table">
            <thead>
              <tr>
                {[
                  { label: 'Name', key: 'tournamentName' },
                  { label: 'Fee', key: 'entryFee' },
                  { label: 'Entries', key: 'entrants' },
                  { label: 'Winner', key: 'winnerName' }
                ].map(({ label, key }) => (
                  <th key={key} onClick={() => requestSort(key)}>
                    {label} {getSortIndicator(key)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sortedContests.map(contest => {
                  const isUserEntered =
                    userId &&
                    contest.entrants?.some((entrant) => entrant.userId === userId);

                  return {
                      ...contest,
                      winnerName: getWinnerName(contest),
                      entrants: getEntrantsCount(contest),
                      isUserEntered: isUserEntered
                  }
              }).map((contest, index) => (
                <tr key={contest._id || index} className="contest-row" onClick={() => handleContestClick(contest._id)}>
                  <td data-label="Name">
                    {contest.isUserEntered && (
                      <span title="You have an entry in this contest">⭐ </span>
                    )}
                    {contest.tournamentName}
                  </td>
                  <td data-label="Fee">${(contest.entryFee || 0) + (contest.adminFee || 0)}</td>
                  <td data-label="Entries">{contest.entrants}</td>
                  <td data-label="Winner">{contest.winnerName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CompletedContests;
